export default "__VITE_ASSET__BpBJ9yTB__"